<template>
  <div>
    <el-dialog
      class="newDialog"
      title="檔案上傳"
      :visible.sync="visible"
      height="100%"
      :before-close="handleClose"
    >
      <el-upload
        ref="upload"
        action
        multiple
        :limit="5"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :file-list="fileList"
        :auto-upload="false"
        accept="image/jpeg, image/png, image/gif, application/pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .csv, .zip"
      >
        <button
          id="openfile"
          slot="trigger"
          class="el-button el-button--success el-button--small"
        >選擇</button>
        <el-button
          style="margin-left: 10px;"
          size="small"
          type="success"
          @click="newSubmitForm()"
        >送出</el-button>
      </el-upload>
    </el-dialog>
  </div>
</template>


<script>
import Global from "@/components/Global";
import { UploadHandler } from "@/handler/UploadHandler.js";

export default {
  name: "Upload",
  data() {
    return {
      visible: false,
      fileList: []
    };
  },
  methods: {
    inidata: function() {
      this.visible = true;
      this.fileList = [];
      this.$nextTick(() => {
        $("#openfile").trigger("click");
      });
    },
    handleClose(done) {
      done();
    },
    beforeUpload(file) {
      var isimg =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/gif";
      var isvedio = file.type === "video/mp4";
      isvedio = false;
      var isdoc = /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt|csv|zip)$/i.test(file.name);
      if (!isimg && !isvedio && !isdoc) {
        alert("不支援的檔案格式上傳");
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        alert("上傳檔案大小不能超過10MB！");
        return false;
      }

      var messagetype = 0;
      if (isimg) {
        messagetype = 4;
      }
      if (isvedio) {
        messagetype = 6;
      }
      if (!isimg && !isvedio && isdoc) {
        messagetype = 2;
      }

      //上傳檔案
      let resp = UploadHandler.Upload(file, messagetype);
      if (resp.Success) {
        this.visible = false;
      } else {
        alert(resp.DisplayMessage || "上傳失敗");
      }
      return false;
    },
    handleExceed(files, fileList) {
      alert("當前限制選擇 5 個文件");
    },
    newSubmitForm() {
      this.$refs.upload.submit();
    }
  }
};
</script> 



<style>
</style>



// WEBPACK FOOTER //
// src/components/Main/ChatToolBar_Upload.vue